import React from "react";
import {
  CheckCircle,
  Trophy,
  UserPlus,
  FileText,
  BarChart2,
  Repeat,
} from "lucide-react";
import Header from "../../components/user/Header";
import infoBg from "../../images/Baseball2.jpg";
import Footer from "../../components/user/Footer";

export default function HowItWorks() {
  const steps = [
    {
      id: 1,
      title: "Register as an Athlete",
      icon: <UserPlus size={40} />,
      description:
        "Create your athlete account on the NLSA CHALLENGE platform. This builds your official profile in the National Stat Database. All certified tests, certificates, and tiers remain stored forever.",
    },
    {
      id: 2,
      title: "Choose Your Sport Challenge",
      icon: <Trophy size={40} />,
      description: (
        <>
          Athletes choose from the following sports:
          <ul className="mt-2">
            <li>Basketball</li>
            <li>Football</li>
            <li>Baseball</li>
            <li>Soccer</li>
            <li>Hockey</li>
          </ul>
          Each sport has its own NLSA USA performance tests.
        </>
      ),
    },
    {
      id: 3,
      title: "Complete the NLSA CHALLENGE Performance Tests",
      icon: <CheckCircle size={40} />,
      description:
        "During a NLSA CHALLENGE event or testing session, athletes complete standardized performance tests verified by an NLSA USA official.",
    },
    {
      id: 4,
      title: "Receive Certified NLSA CHALLENGE Results",
      icon: <FileText size={40} />,
      description: (
        <>
          Athletes receive:
          <ul className="mt-2">
            <li>Certified Stat Report</li>
            <li>Titan Tier (Bronze, Silver, Gold, Elite)</li>
            <li>Placement in the National Stat Database</li>
            <li>Downloadable Certificate</li>
          </ul>
        </>
      ),
    },
    {
      id: 5,
      title: "Access the Athlete Dashboard",
      icon: <BarChart2 size={40} />,
      description: (
        <>
          Athletes can:
          <ul className="mt-2">
            <li>View certificates</li>
            <li>Track stat history</li>
            <li>Monitor tier status</li>
            <li>Start new NLSA CHALLENGEs</li>
          </ul>
        </>
      ),
    },
    {
      id: 6,
      title: "Improve Over Time",
      icon: <Repeat size={40} />,
      description:
        "Athletes can retest or compete in multiple sports. Every certified attempt boosts their tier and national ranking.",
    },
  ];

  return (
    <section style={{ background: "#f7f9fc" }}>
      <Header />
      <section
        className="py-5 position-relative text-white d-flex align-items-center"
        style={{
            backgroundImage: `url(${infoBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height: "400px",
        }}
        >
        {/* Dark Overlay */}
        <div
            style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.55)",
            zIndex: 1,
            }}
        ></div>

        {/* Content */}
        <div
            className="container text-center position-relative"
            style={{ zIndex: 2 }}
        >
            <h2 className="fw-bold display-6">HOW THE NLSA CHALLENGE WORKS</h2>
        </div>
      </section>
      <br />
      {/* Steps Grid */}
      <div className="container">
        <div className="row g-4">
          {steps.map((step) => (
            <div key={step.id} className="col-md-6">
              <div className="card h-100 shadow-sm border-0 rounded-4 p-3 hover-scale">
                <div className="d-flex align-items-center mb-3">
                  <div className="text-primary me-3">{step.icon}</div>
                  <h5 className="fw-bold mb-0">
                    {step.id}. {step.title}
                  </h5>
                </div>
                <p className="text-secondary mb-0">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Hover Scale Animation */}
      <style>{`
        .hover-scale {
          transition: 0.3s ease;
        }
        .hover-scale:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
        }
        ul {
          padding-left: 18px;
        }
      `}</style>
      <Footer />
    </section>
  );
}